// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__header{background:#1a243e;display:flex}.el-tooltip__popper{width:40vw}", ""]);
// Exports
module.exports = exports;
